// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f2a2Y9yhW423Y1fP9k9Y{flex-direction:column;padding-bottom:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `f2a2Y9yhW423Y1fP9k9Y`
};
export default ___CSS_LOADER_EXPORT___;
